import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { removeActionTypes }    from 'Utils/ReducerUtility';
import { IAppUserState }        from 'Redux/Slices/AppUser/AppUserSlice';

export const removeAppUserOrganisationRequest = (state: Draft<IAppUserState>, { type }: PayloadAction<{ userId: string, organisationId: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const removeAppUserOrganisationSuccess = (state: Draft<IAppUserState>, { type, payload }: PayloadAction<{ organisationId: string }>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.organisations = state.organisations.filter((organisation) => organisation.organisationId !== payload.organisationId);
  delete state.assignedEventIdsByOrganisation[payload.organisationId];
};

export const removeAppUserOrganisationFailure = (state: Draft<IAppUserState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
